// extracted by mini-css-extract-plugin
module.exports = {"svgIcon":"SvgIcon_svgIcon__nr2r8","fillContainer":"SvgIcon_fillContainer__U4etv"};